import en from "./languages/en.json";
import sv from "./languages/sv.json";
const format_for_react_intl = (data) => {
    const result = {};
    Object.keys(data).forEach((k) => {
        result[k] = data[k].string;
    });
    return result;
};
export const messages = {
    en: format_for_react_intl(en),
    sv: format_for_react_intl(sv),
};
